import * as _ from 'underscore';
import * as $ from 'jquery';

import * as DateTimeFunctions from '../../../../_common/platform/ts/DateTimeFunctions';
import * as Globalization from '../../../../_common/platform/ts/Globalization';
import { ATTRIBUTE_TYPES } from '../../../../_common/platform/ts/ConfigurationConstants';
import { ChartPropsManager } from '../ChartPropsManager';
import { themeVars } from '../../../../pdc-platform/src/ts/themes/themeConstants';
import { FontWrapper, LabelsFormatWrapper, NotificationCallWrapper } from '../DashboardWidget_dxChart_Parametrized';
import { themeFields } from '../themes/themeFields';
import { ChartElementsFormatKeys } from './ChartElementsFormatSelect';

//LL: for all X and Y and AUX
class TickIntervalWrapper {
    public static createTickInterval(wParams, axis, dataType) {
        // wParams not needed ?    axis ~~ wParams.argumentAxis   dataType ~~ argType
        let tickInterval: any; // Type: Number|Object|String
        switch (dataType) {
            case 'i':
                tickInterval = axis.tickInterval_Integer;
                if (tickInterval == null) {
                    tickInterval = axis.tickInterval;
                } // for AUX

                //  was: if (tickInterval < 1) tickInterval = 1;
                //LL: for FullStacked values are interpret as percents, more strictly as decimal fractions of 100%
                //          So, tickInterval = 1 is full scale !!!   must be set < 1
                if (axis.hasFullStacked !== true) {
                    if (tickInterval < 1) {
                        tickInterval = 1;
                    }
                }

                break;
            case 'r':
                tickInterval = axis.tickInterval_Real;
                if (tickInterval == null) {
                    tickInterval = axis.tickInterval;
                } // for AUX
                if (tickInterval === 0) {
                    tickInterval = null;
                }
                break;
            case 'datetime':
            case 'date':
            case 'time':
                if (axis.tickDateIntervalType != null && axis.tickDateIntervals != null) {
                    tickInterval = {};
                    tickInterval[axis.tickDateIntervalType] = axis.tickDateIntervals;
                }
                break;
            default:
        }
        return tickInterval;
    }
}

//LL: for X and Y.  Not used now for AUX
class MinMaxWrapper {
    public static createMinMax(wParams, axis, dataType) {
        // Type: Number|Date
        // wParams not needed ?    axis ~~ wParams.argumentAxis   dataType ~~ argType
        let min;
        let max;
        if (axis.useMinValue === true || axis.useMaxValue === true) {
            switch (dataType) {
                case 'i':
                    min = axis.minValue_Integer;
                    max = axis.maxValue_Integer;
                    break;
                case 'r':
                    min = axis.minValue_Real;
                    max = axis.maxValue_Real;
                    break;
                case 'datetime':
                case 'date':
                case 'time':
                    min = axis.minValue_Date;
                    max = axis.maxValue_Date;
                    break;
                default:
            }
        }
        return { min: min, max: max };
    }
}

//LL: Ys.  and AUX
class SynchronizedOnWrapper {
    public static createSynchronizedOn(wParams, axis, dataType) {
        // Type: Number|Date|String
        // wParams not needed ?    axis ~~ wParams.argumentAxis   dataType ~~ argType
        let synchOn: any = null; // Type: Number|Date|String
        if (wParams.synchronizeMultiAxes === false) {
            // true default
            return synchOn;
        }
        switch (dataType) {
            case 'i':
                synchOn = axis.synchronizedOn_Integer;
                break;
            case 'r':
                synchOn = axis.synchronizedOn_Integer;
                break;
            case 'datetime':
            case 'date':
            case 'time':
                let sd = axis.synchronizedOn_Date;

                if (sd != null) {
                    if (typeof sd === 'string') {
                        let date = Date.parse(sd);
                        if (isNaN(date)) {
                            sd = null;
                        } else {
                            sd = new Date(date);
                        }
                    } else if (typeof sd === 'number') {
                        if (isNaN(sd)) {
                            sd = null;
                        } else {
                            //sd = new Date(sd);
                            if (dataType === 'time') {
                                sd = null;
                            } else {
                                sd = new Date(sd);
                            }
                        }
                    }
                }
                synchOn = sd;
                break;
            default:
        }
        return synchOn;
    }
}

export class ChartAxisWrapper {
    //LL: for DevExpr 16.1
    //  https://js.devexpress.com/Documentation/16_1/Guide/Data_Visualization/Common/Data_Formatting/#Data_Formatting
    //  added formats:
    //   'longDateLongTime' - "Thursday, January 01, 1970, 12:00:00 AM"
    //   'shortDateShortTime' - "1/25/1970, 12:00 AM"
    //   'dayOfWeek' - "Thursday"
    //   'hour' - "12"
    //   'minute' - "00"
    private static evalCustomFormat(format, customFormat, externFunctions, dataType) {
        // return {format:f, custom:custom};
        let f = format;
        let custom = false;
        let timeInterval = false;
        if (format === 'Long+Long' || format === 'longDateTime') {
            //f = 'F';
            //custom = true;
            f = 'longDateLongTime'; //LL:  not custom !!!
        } // F	Long Date, Long Time   dddd, MMMM dd, yyyy h:mm:ss tt
        if (format === 'Long+Short' || format === 'shortDateTime') {
            //f = 'f';
            //custom = true;
            f = 'shortDateShortTime'; //LL:  not custom !!!
        } //  f	Long Date, Short Time	dddd, MMMM dd, yyyy h:mm tt
        if (format === 'Standard' || format === 'Universal') {
            f = 'S';
            custom = true;
        } // sortable format  "yyyy'-'MM'-'dd'T'HH':'mm':'ss"  It is identical in every culture

        if (format === 'custom') {
            f = 'custom';
            custom = true;
        }

        if (!custom) {
            if (externFunctions != null) {
                let arrTimeIntervalFormats = [];

                if (dataType === ATTRIBUTE_TYPES.INTEGER) {
                    // if (typeof externFunctions.getFormatFrontArray_TimeIntervals_Int_Func === 'function') {
                    //     arrTimeIntervalFormats = externFunctions.getFormatFrontArray_TimeIntervals_Int_Func();
                    // }
                    arrTimeIntervalFormats = ChartPropsManager.getFormatFrontArray_TimeIntervals_Int();
                }

                if (dataType === ATTRIBUTE_TYPES.REAL) {
                    // if (typeof externFunctions.getFormatFrontArray_TimeIntervals_Real_Func === 'function') {
                    //     arrTimeIntervalFormats = externFunctions.getFormatFrontArray_TimeIntervals_Real_Func();
                    // }
                    arrTimeIntervalFormats = ChartPropsManager.getFormatFrontArray_TimeIntervals_Real();
                }

                let fnd = false;

                for (let i = 0; i < arrTimeIntervalFormats.length; i++) {
                    if (arrTimeIntervalFormats[i] === format) {
                        fnd = true;
                        break;
                    }
                }

                if (fnd) {
                    custom = true;
                    timeInterval = true;
                }

                //LL: 03.04.25: formatting Integers as TimeParts
                if (!fnd && dataType === ATTRIBUTE_TYPES.INTEGER) {
                    let arr = ChartPropsManager.integer_TimePartFormats();
                    let fnd2 = _.find(arr, (fs) => {
                        return fs === format;
                    });

                    if (fnd2 != null) {
                        custom = true;
                        timeInterval = true; //LL: actually is TimePart format
                    }
                }
            }
        }

        return { format: f, custom: custom, timeInterval: timeInterval };
    }

    public static getLabelFormatAndPrecision(_kind, _wParams, dataType, _theme, _paa?) {
        let wAxis;
        if (_kind === 'x' || _kind === 'X') {
            wAxis = _wParams.argumentAxis;
        } else if (_kind === 'y' || _kind === 'Y') {
            wAxis = _wParams.valueAxis;
        } else if (_kind === 'a' || _kind === 'A') {
            wAxis = _paa;
        }

        if (wAxis == null) {
            return null;
        }

        let lf;
        let prec;
        let currency;

        let axis_customFormat = false;
        if (wAxis.labelsFormat != null && wAxis.labelsFormat != '' && wAxis.labelsFormat != 'default') {
            let cf = ChartAxisWrapper.evalCustomFormat(
                wAxis.labelsFormat,
                wAxis.customFormat,
                _wParams.externalFunctions,
                dataType
            ); // return {format:f, custom:custom};

            axis_customFormat = cf.custom;

            if (!cf.custom) {
                lf = cf.format;
                if (_kind === 'x') {
                    // Не получается для оси Y дает exception в Globalize.formatNumber
                    const use24hours = _theme[themeVars.use24HoursFormat];

                    lf = Globalization.getFormatSpecifier(lf, use24hours);
                }
            } else {
                // now only for DateTime,
                if (cf.timeInterval !== true) {
                    lf = LabelsFormatWrapper.getFormatterFunction(
                        cf.format,
                        dataType,
                        cf.timeInterval,
                        wAxis.customFormat
                    );
                } else {
                    lf = cf.format;
                }
            }
        }

        if (wAxis.labelsPrecision != null && !axis_customFormat && lf != null) {
            prec = wAxis.labelsPrecision;
        }

        if (wAxis.labelsCurrency != null && !axis_customFormat && lf != null) {
            currency = wAxis.labelsCurrency;
        }

        return {
            format: lf,
            precision: prec,
            custom: axis_customFormat,
            currency: currency
        };
    }

    private wParams: any = {};
    private kind = 'X';
    private paa;

    constructor(_wParams, _kind, _paa?) {
        this.wParams = _wParams;
        this.kind = _kind;
        if (_paa != null) {
            this.paa = _paa;
        }
    }

    private isX() {
        return this.kind === 'x' || this.kind === 'X';
    }

    private isY() {
        return this.kind === 'y' || this.kind === 'Y';
    }

    private isA() {
        return this.kind === 'a' || this.kind === 'A';
    }

    private isNotDiscrete(axisType) {
        let notDiscrete = false;
        if (this.isX()) {
            notDiscrete = axisType === 'continuous' || axisType === 'logarithmic';
        } else if (this.isY() || this.isA()) {
            notDiscrete =
                axisType == null || axisType === 'default' || axisType === 'continuous' || axisType === 'logarithmic';
        }
        return notDiscrete;
    }

    private getAxisTypeName() {
        let s = '';
        if (this.isX()) {
            s = 'Argument';
        } else if (this.isY()) {
            s = 'Value';
        } else if (this.isA()) {
            s = 'Secondary';
        }
        return s;
    }

    public createAxis(
        dataType,
        strips,
        constantLines,
        breaks,
        _ArgumentAndPointLabels,
        dataTimePart,
        labelsFormatIsDefault,
        _theme
    ) {
        // dataType == argType, yType, aaType
        let wAxis;

        if (this.isX()) {
            wAxis = this.wParams.argumentAxis;
        } else if (this.isY()) {
            wAxis = this.wParams.valueAxis;
        } else if (this.isA()) {
            wAxis = this.paa;
        }

        if (wAxis == null) {
            console.log('  ChartAxisWrapper createAxis:  wAxis == null ');
            return null;
        }

        let self = this;

        //LL: visible deprecated, use show
        let axis_axisLineVisible = wAxis.show && wAxis.axisLineVisible;
        let axis_labelsVisible = wAxis.show && wAxis.labelsVisible;

        // axisType: 'default'  // 'discrete', 'continuous', 'logarithmic'
        let axis_axisType = wAxis.axisType;
        let axis_useDefaultAxisType = axis_axisType == null || axis_axisType === 'default' ? true : false;

        let axis_useCategories = true;
        if (
            this.isNotDiscrete(axis_axisType) &&
            (dataType === 'i' || dataType === 'r' || dataType === 'b' || DateTimeFunctions.isTypeOfAnyDate(dataType))
        ) {
            axis_useCategories = false;
        }

        if (this.isX()) {
            if (
                (axis_axisType === 'continuous' || axis_axisType === 'logarithmic') &&
                dataTimePart != null &&
                dataTimePart !== 'none' &&
                labelsFormatIsDefault
            ) {
                axis_useCategories = false;
            }
        }

        //LL:  'logarithmic' only for numeric:
        let atn = this.getAxisTypeName();
        if (axis_axisType === 'logarithmic' && (dataType === 'b' || DateTimeFunctions.isTypeOfAnyDate(dataType))) {
            axis_axisType = 'continuous';
            //LL: <br>, not '\n'  -- will be inside <span> :
            NotificationCallWrapper.notify(
                'warning',
                atn +
                    ' Axis Type "logarithmic" is valid only for numeric Arguments.<br>' +
                    atn +
                    ' Axis Type is changed to "continuous"',
                true
            );
        }

        let axis_dataType = 'string'; // axis_argumentType  valueAxis_valueType   //  'numeric' | 'datetime' | 'string'
        let axis_useDataType = false; // axis_useArgumentType  valueAxis_valueType;
        let axis_useLabelFormat = true; //  for valueAxis_useLabelFormat  is set, but not used

        switch (dataType) {
            case 'i':
                //  will be 'numeric' by default (by data source)
                //LL: when Time Parts  All kinds
                if (!ChartPropsManager.ApplyFormattedTimeParts && dataTimePart != null && dataTimePart !== 'none') {
                    axis_useLabelFormat = false; //LL: formatting will be applied by customizeText
                }
                break;

            case 'r':
                //  will be 'numeric' by default (by data source)
                break;

            case 'datetime':
            case 'date':
            case 'time':
                axis_dataType = 'datetime';
                axis_useDataType = true;

                if (this.isY() || this.isA()) {
                    axis_useDataType = axis_axisType === 'continuous' ? true : false;
                }
                break;

            case 's':
                axis_useDataType = true;
                axis_useLabelFormat = false;

                if (this.isX()) {
                    axis_dataType = 'string';
                }
                break;

            case 'e':
            case 'b':
                axis_dataType = 'string';
                axis_useDataType = true;
                axis_useLabelFormat = false;
                break;
            default:
                axis_dataType = 'string';
                //axis_useDataType = true;
                axis_useLabelFormat = false;
        }

        //  The following values can be specified for both horizontal and vertical axes:  'hide', 'none'
        //  The following values can be specified for horizontal axes only: 'rotate', 'stagger'
        let overlappingBehavior = 'hide';

        if (this.isX()) {
            overlappingBehavior = this.wParams.rotatedXY ? 'hide' : this.wParams.horizontalAxis_overlappingBehavior;
        } else {
            overlappingBehavior = !this.wParams.rotatedXY ? 'hide' : this.wParams.horizontalAxis_overlappingBehavior;
        }

        let axis: any = {
            discreteAxisDivisionMode: 'crossLabels', // Specifies whether ticks/grid lines of a discrete axis are located between labels or cross the labels.  default='betweenLabels'

            // axisDivisionFactor   ----------------
            //   Specifies the minimum distance between two neighboring major ticks in pixels. Applies only to the axes of the "continuous" and "logarithmic" types.
            //   Type: Number
            //Default Value: 30  (in 17.1 ver)
            //  For axes displaying numbers, the distance between major ticks depends on two
            //  interconnected options: axisDivisionFactor and tickInterval.
            //  Consider that you have specified both these options.
            //  If the specified tick interval leads the pixel distance between two ticks
            //  to being less than the axisDivisionFactor value, this tick interval will be ignored.
            //
            //    Use the axisDivisionFactor option only if you need to set the distance between ticks not knowing the axis values. Otherwise, use the tickInterval option.
            //----------------

            visible: axis_axisLineVisible,

            width: wAxis.width != null ? wAxis.width : 1,
            inverted: wAxis.inverted != null ? wAxis.inverted : false,
            position: wAxis.position != null ? wAxis.position : 'right', // 'right' for AUX, other always has ?

            grid: { visible: wAxis.gridLinesVisible },
            tick: {
                visible: wAxis.show && wAxis.ticksVisible,
                opacity: 0.75
            },

            minorGrid: { visible: wAxis.minorGridLinesVisible },
            minorTick: {
                visible: wAxis.show && wAxis.minorTicksVisible,
                opacity: 0.75
            },

            label: {
                visible: axis_labelsVisible,

                //LL: about "rotationAngle":
                //   It is used either by "overlappingBehavior" - when Labels ARE overlapped,
                //             but not if there is enough space
                //   Or by "displayMode" -no need overlapping (since DevExpress 17)
                overlappingBehavior: overlappingBehavior,
                //staggeringSpacing: 3, // def 5
                rotationAngle: this.wParams.argumentAngle, // clockwise from axis
                //LL: Accepted Values: 'rotate' | 'stagger' | 'standard'
                displayMode: this.wParams.horizontalAxis_displayMode
            }
        };

        //LL: for Aux:
        if (wAxis.name != null) {
            axis.name = wAxis.name;
        }

        if (strips != null) {
            axis.strips = strips;
        }
        if (constantLines != null) {
            axis.constantLines = constantLines;
        }

        if (breaks != null) {
            axis.breaks = breaks;
        }

        if (this.isX() || this.isY()) {
            if (wAxis.breaks != null) {
                if (this.isY()) {
                    if (wAxis.breaks.breaksAutoEnabled != null) {
                        axis.autoBreaksEnabled = wAxis.breaks.breaksAutoEnabled;
                    }
                    if (wAxis.breaks.breaksAutoMaxCount != null) {
                        axis.maxAutoBreakCount = wAxis.breaks.breaksAutoMaxCount;
                    }
                }
                if (wAxis.breaks.breaksColor != null) {
                    if (axis.breakStyle == null) {
                        axis.breakStyle = {};
                    }
                    axis.breakStyle.color = wAxis.breaks.breaksColor;
                }
                if (wAxis.breaks.breaksWidth != null) {
                    if (axis.breakStyle == null) {
                        axis.breakStyle = {};
                    }
                    axis.breakStyle.width = wAxis.breaks.breaksWidth;
                }
                if (wAxis.breaks.breaksLineStyle != null) {
                    if (axis.breakStyle == null) {
                        axis.breakStyle = {};
                    }
                    axis.breakStyle.line = wAxis.breaks.breaksLineStyle;
                }
            }
        }

        let tickInterval = TickIntervalWrapper.createTickInterval(this.wParams, wAxis, dataType);

        if (tickInterval == null) {
            if (this.isX() || this.isY()) {
                if (!ChartPropsManager.ApplyFormattedTimeParts && dataTimePart != null && dataTimePart !== 'none') {
                    tickInterval = 1;
                }
            }
        }
        if (tickInterval != null) {
            axis.tickInterval = tickInterval;
        }

        if (wAxis.minorTickCount != null) {
            axis.minorTickCount = wAxis.minorTickCount;
        }

        if (wAxis.axisDivisionFactor != null) {
            axis.axisDivisionFactor = wAxis.axisDivisionFactor;
        }

        let titleText = wAxis.title;

        if (titleText == null || titleText === '') {
            titleText = wAxis.name;
        } //LL: for Aux

        if (wAxis.show && titleText != null && titleText != '') {
            let title: any = {};

            title.text = titleText;

            if (wAxis.color != null) {
                title.font = { color: wAxis.color };
            }
            axis.title = title;
        }

        if (wAxis.color != null) {
            axis.color = wAxis.color;
            axis.label.font = { color: wAxis.color };
            //LL: Axis Lines, Grid Lines, MinorGrid Lines, Ticks, Labels - all can have their own color.
            axis.grid.color = wAxis.color;
            axis.minorGrid.color = wAxis.color;
            axis.tick.color = wAxis.color;
            axis.minorTick.color = wAxis.color;
        }

        if (wAxis.colorLabels != null) {
            axis.label.font = { color: wAxis.colorLabels };
        }

        let fo = FontWrapper.createFontObj_fromTheme(this.wParams, _theme, themeFields.font_inAxisLabels);
        let fo2 = FontWrapper.createFontObj_fromValues(wAxis.fontFace, wAxis.fontSize, wAxis.fontWeight);
        //LL: 28.09.21: undocumented param "style" works!!!
        if (wAxis.fontItalic === true) {
            fo2.style = 'italic';
        }
        if (axis.label.font == null) {
            axis.label.font = {};
        }
        _.extend(axis.label.font, fo, fo2); // shallow
        //
        if (axis.title != null) {
            if (axis.title.font == null) {
                axis.title.font = {};
            }
            _.extend(axis.title.font, fo, fo2); // shallow
        }
        //LL: try, see https://js.devexpress.com/Demos/WidgetsGallery/Demo/Charts/AxisLabelsTemplates/jQuery/Light/
        //    Sample is from there.
        //LL: better way: see above "fo2.style = 'italic';" - undocumented param "style" works!
        if (this.isX()) {
            //axis.label.template = function(data: any, g) {
            //    //var content = $('<svg overflow="visible">' +
            //    //    '<image filter="url(#DevExpress_shadow_filter)" y="0" width="60" height="40" href="' +
            //    //    getFilePath(data.valueText) +'"></image>' +
            //    //    '<text class="template-text" x="30" y="59" text-anchor="middle">' + data.valueText + '</text></svg>');
            //    //
            //    //g.appendChild(content.get(0));
            //
            //    //LL: experiment, wrong
            //    data.labelFontStyle["font-style"] = 'italic';
            //    return g; //LL: no sense
            //};
        }

        if (!axis_useDefaultAxisType) {
            axis.type = axis_axisType;
        }

        //LL:  for valueAxis_useLabelFormat  is set, but not used - OLD
        if (
            (this.isY() && ChartPropsManager.ApplyFormattedTimeParts && dataTimePart == null) ||
            (this.isA() && ChartPropsManager.ApplyFormattedTimeParts && dataTimePart == null)
        ) {
            axis_useLabelFormat = true;
        }
        //LL: for DevExpr 16.1:
        let axis_customFormat = false;

        if (
            axis_useLabelFormat &&
            wAxis.labelsFormat != null &&
            wAxis.labelsFormat !== '' &&
            wAxis.labelsFormat !== 'default'
        ) {
            let cf = ChartAxisWrapper.evalCustomFormat(
                wAxis.labelsFormat,
                wAxis.customFormat,
                this.wParams.externalFunctions,
                dataType
            ); // return {format:f, custom:custom};

            axis_customFormat = cf.custom;

            if (!cf.custom) {
                const use24hours = _theme[themeVars.use24HoursFormat];

                //cf.format = Globalization.getFormatSpecifier(cf.format, use24hours);
                //axis.label.format = cf.format;
                //LL: raw -> custom string   Or maybe use getFormatterFunction as below
                let fff = Globalization.getFormatSpecifier(cf.format, use24hours);

                if (typeof fff !== 'string' && fff.raw != null) {
                    fff = fff.raw;
                }

                cf.format = fff;
                axis.label.format = fff;
            } else {
                // now only for DateTime,  //LL: for i & r also as TimeIntervals
                //LL: 08.04.25
                const use24hours = _theme[themeVars.use24HoursFormat];
                const firstWeekDay = _theme['widget-culture-first-week-day']; //LL:  "fri", "sun"
                let fiscalFirstMonth = _theme[themeVars.fiscalFirstMonth]; // 'widget-fiscal-first-month' // "3" (March)
                //LL: 08.04.25: add formatOptions //{use24hours: use24hours, firstWeekDay: firstWeekDay, fiscalFirstMonth: fiscalFirstMonth}
                //  IValueFormat:
                // use24hours?: boolean;
                // firstDayOfWeek?: string;
                // fiscalFirstMonth?: number;
                if (typeof fiscalFirstMonth === 'string') {
                    let num = Number(fiscalFirstMonth);
                    if (!isNaN(num)) {
                        fiscalFirstMonth = num;
                    } else {
                        fiscalFirstMonth = null;
                    }
                }

                axis.label.format = LabelsFormatWrapper.getFormatterFunction(
                    cf.format,
                    dataType,
                    cf.timeInterval,
                    wAxis.customFormat,
                    { use24hours: use24hours, firstDayOfWeek: firstWeekDay, fiscalFirstMonth: fiscalFirstMonth } //LL: 08.04.25
                );
            }
        }

        let formatType = axis.label.format;

        if (formatType != null && typeof formatType !== 'function') {
            let toObj = false;
            let currency;

            if (!_.isObject(formatType) && formatType.indexOf('currency') >= 0 && this.wParams.currency != null) {
                currency = this.wParams.currency;
                toObj = true;
            }
            if (wAxis.labelsCurrency != null) {
                currency = wAxis.labelsCurrency;
                toObj = true;
            }

            let precision;
            if (
                axis_useLabelFormat &&
                !axis_customFormat &&
                axis_dataType !== 'datetime' &&
                wAxis.labelsPrecision != null
            ) {
                precision = wAxis.labelsPrecision;
                toObj = true;
            }

            if (toObj) {
                axis.label.format = { type: formatType };
            }
            if (currency != null) {
                axis.label.format.currency = currency;
            }
            if (precision != null) {
                axis.label.format.precision = precision;
            }

            //  See also below label_customizeText_Y, but for TimeParts
            ////LL: TRY  error when name is "<NOT SET>":     change "<" by &lt
            if (!_.isObject(formatType) && formatType.indexOf('currency') >= 0) {
                axis.label.customizeText = (obj) => {
                    //value	Date | Number | String	The raw argument value.
                    //valueText	String	The formatted value converted to a string.

                    let formatObj = {
                        formatFront: formatType, // "currency",
                        precision: precision,
                        currency: currency,
                        type: dataType // 'r'
                    };
                    let valueText = LabelsFormatWrapper.getFormattedValue_by_FormatObj(obj.value, formatObj, currency);
                    if (valueText != null) {
                        return valueText;
                    }

                    return obj.valueText;
                };
            }
        }

        let min_max = MinMaxWrapper.createMinMax(this.wParams, wAxis, dataType);
        let aMin, aMax;

        if (wAxis.useMinValue === true && min_max.min != null) {
            aMin = min_max.min;
        }

        if (wAxis.useMaxValue === true && min_max.max != null) {
            aMax = min_max.max;
        }

        if (aMin != null || aMax != null) {
            axis.visualRange = {};
            if (aMin != null) {
                axis.visualRange.startValue = aMin;
            }
            if (aMax != null) {
                axis.visualRange.endValue = aMax;
            }
        }

        let zoomState = this.wParams.externalFunctions.zoomState;
        //LL: old zoom by rangeSelector
        if (this.isX()) {
            let rangeValue: any;

            if (zoomState != null && zoomState.rangeSelector != null) {
                let v1 = zoomState.rangeSelector.v1;
                let v2 = zoomState.rangeSelector.v2;
                if (v1 != null || v2 != null) {
                    rangeValue = {};
                }
                if (v1 != null) {
                    rangeValue.startValue = v1;
                }
                if (v2 != null) {
                    rangeValue.endValue = v2;
                }
            }

            if (rangeValue != null) {
                if (axis.visualRange == null) {
                    axis.visualRange = {};
                }
                if (rangeValue.startValue != null) {
                    if (axis.visualRange.startValue == null) {
                        axis.visualRange.startValue = rangeValue.startValue;
                    } else if (axis.visualRange.startValue < rangeValue.startValue) {
                        axis.visualRange.startValue = rangeValue.startValue;
                    }
                }
                if (rangeValue.endValue != null) {
                    if (axis.visualRange.endValue == null) {
                        axis.visualRange.endValue = rangeValue.endValue;
                    } else if (axis.visualRange.endValue > rangeValue.endValue) {
                        axis.visualRange.endValue = rangeValue.endValue;
                    }
                }
            }
        }
        //LL: new zoom/scroll by ZoomAndPan
        let rangeValue2: any;

        if (zoomState != null && zoomState.zoomAndScroll != null) {
            if (
                (this.isX() && zoomState.zoomAndScroll.isArgAxis) ||
                (this.isY() && !zoomState.zoomAndScroll.isArgAxis)
            ) {
                let v1 = zoomState.zoomAndScroll.v1;
                let v2 = zoomState.zoomAndScroll.v2;
                if (v1 != null || v2 != null) {
                    rangeValue2 = {};
                }
                if (v1 != null) {
                    rangeValue2.startValue = v1;
                }
                if (v2 != null) {
                    rangeValue2.endValue = v2;
                }
            }
        }

        if (rangeValue2 != null) {
            if (axis.visualRange == null) {
                axis.visualRange = {};
            }
            if (rangeValue2.startValue != null) {
                if (axis.visualRange.startValue == null) {
                    axis.visualRange.startValue = rangeValue2.startValue;
                } else if (axis.visualRange.startValue < rangeValue2.startValue) {
                    axis.visualRange.startValue = rangeValue2.startValue;
                }
            }
            if (rangeValue2.endValue != null) {
                if (axis.visualRange.endValue == null) {
                    axis.visualRange.endValue = rangeValue2.endValue;
                } else if (axis.visualRange.endValue > rangeValue2.endValue) {
                    axis.visualRange.endValue = rangeValue2.endValue;
                }
            }
        }

        if (this.isY() || this.isA()) {
            //   wAxis is wParams.valueAxis;  dataType is yType
            let synchronizedOn_Y: any = null; // Type: Number|Date|String
            //LL: for Aux - always, for Y - only if Aux exist
            if (this.isA() || wAxis.auxAxis.length > 0) {
                synchronizedOn_Y = SynchronizedOnWrapper.createSynchronizedOn(this.wParams, wAxis, dataType);
            }

            if (synchronizedOn_Y != null) {
                axis.synchronizedValue = synchronizedOn_Y;
            }

            if (dataType === 'b') {
                axis.type = 'discrete';
            }
        }

        //LL: try maxValueMargin for "outside" point labels   OK
        //if (this.isY()) {
        //    axis.maxValueMargin = 0.4;
        //}
        if (wAxis.maxMargin != null) {
            axis.maxValueMargin = wAxis.maxMargin;
        }
        if (wAxis.minMargin != null) {
            axis.minValueMargin = wAxis.minMargin;
        }

        if (axis_useDataType) {
            if (this.isX()) {
                axis.argumentType = axis_dataType;
            } else if (this.isY()) {
                axis.valueType = axis_dataType;
            } else if (this.isA() && axis_dataType != null) {
                axis.valueType = axis_dataType;
            }
        }

        if (this.isX()) {
            //LL: label customization for TimeParts for non-discrete:
            //  if (ApplyFormattedTimeParts)   old = true
            //  if (! ApplyFormattedTimeParts) => all axis.type
            if (
                (_ArgumentAndPointLabels != null && !(axis.type === 'continuous' || axis.type === 'logarithmic')) ||
                (!ChartPropsManager.ApplyFormattedTimeParts && dataTimePart != null && dataTimePart !== 'none')
            ) {
                axis.label.customizeText = label_customizeText_X;
            }
        }

        if (this.isY() || this.isA()) {
            if (!ChartPropsManager.ApplyFormattedTimeParts && dataTimePart != null && dataTimePart !== 'none') {
                axis.label.customizeText = label_customizeText_Y;
            }
        }

        //LL: only for Args:
        function label_customizeText_X() {
            //   valueText, value
            if (_ArgumentAndPointLabels != null) {
                let aplObj = _ArgumentAndPointLabels[this.value];

                if (aplObj != null) {
                    let pl = aplObj.label;

                    if (pl != null && pl != '') {
                        let formatObj;

                        if (aplObj.xL_formats != null) {
                            let elemKey = ChartElementsFormatKeys.argLabel;

                            formatObj = aplObj.xL_formats[elemKey];

                            if (formatObj == null) {
                                formatObj = aplObj.xL_formats[ChartElementsFormatKeys.everywhere];
                            }
                        }

                        if (formatObj != null) {
                            pl = LabelsFormatWrapper.getFormattedValue_by_FormatObj(
                                pl,
                                formatObj,
                                self.wParams.currency
                            );
                        }

                        return pl;
                    }
                }
            }

            // Label customization for Time Parts.
            if (!ChartPropsManager.ApplyFormattedTimeParts && dataTimePart != null && dataTimePart !== 'none') {
                const newValue = LabelsFormatWrapper.convertDate(
                    this.value,
                    dataTimePart,
                    wAxis.labelsFormat,
                    wAxis.customFormat
                );

                if (newValue != null) {
                    return newValue;
                }
            }

            return this.valueText;
        }

        function label_customizeText_Y() {
            // Label customization for Time Parts.
            if (!ChartPropsManager.ApplyFormattedTimeParts && dataTimePart != null && dataTimePart !== 'none') {
                const newValue = LabelsFormatWrapper.convertDate(
                    this.value,
                    dataTimePart,
                    wAxis.labelsFormat,
                    wAxis.customFormat
                );

                if (newValue != null) {
                    return newValue;
                }
            }

            return this.valueText;
        }

        return {
            axis: axis,
            useCategories: axis_useCategories,
            useLabelFormat: axis_useLabelFormat
        };
    }
}
